import { render, staticRenderFns } from "./salaryList.vue?vue&type=template&id=d35f5618&scoped=true"
import script from "./salaryList.vue?vue&type=script&lang=js"
export * from "./salaryList.vue?vue&type=script&lang=js"
import style0 from "./salaryList.vue?vue&type=style&index=0&id=d35f5618&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35f5618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d35f5618')) {
      api.createRecord('d35f5618', component.options)
    } else {
      api.reload('d35f5618', component.options)
    }
    module.hot.accept("./salaryList.vue?vue&type=template&id=d35f5618&scoped=true", function () {
      api.rerender('d35f5618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/salaryList.vue"
export default component.exports